import { FeatureBlock, FeatureComparison } from "../_copy-template"
import Scheduling from "~images/pages/comparison/features/schedule.png"

export function getSchedulingCopy(competitor: FeatureBlock): FeatureComparison {
    return {
        name: "Online Scheduling",
        image: Scheduling,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, your clients are able to view your open availability, filtered by the exact rules you use at your practice. They can then book an appointment in real-time, without needing to call your front desk, and it'll appear in your PIMS like magic.",
        },
        competitor,
        href: "/features/realtime-booking",
    }
}
